import { Listing } from './listing.type';

export const getStatus = (listing: Listing): string => {
    if (listing.underOffer) {
        return 'Under offer';
    }

    if (listing.flag) {
        return listing.flag;
    }

    return '';
};
